import size from 'lodash/size';
import values from 'lodash/values';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TextButton from '@spothero/ui/text-button';
import AmenityFilterItem from './AmenityFilterItem';

export default class AmenitiesFilters extends Component {
    static propTypes = {
        amenities: PropTypes.object.isRequired,
        activeAmenities: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired
    };
    state = {
        showMoreFilters: false
    };

    _onMoreToggle = () => {
        this.setState((prevState, props) => {
            return {
                showMoreFilters: !prevState.showMoreFilters
            };
        });
    }

    render() {
        const {
            amenities,
            activeAmenities,
            onChange
        } = this.props;
        const {
            showMoreFilters
        } = this.state;
        let counter = 0;

        return (
            <div className="AmenitiesFilters">
                <p>Filter spots by selecting amenities.</p>
                <div className="amenities">
                    {values(amenities).map(amenity => {
                        if (counter < 5 || showMoreFilters) {
                            counter++;

                            return (
                                <AmenityFilterItem
                                    key={amenity.slug}
                                    amenity={amenity}
                                    activeAmenities={activeAmenities}
                                    onChange={onChange}
                                />
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
                {size(amenities) > 5 &&
                    <TextButton
                        className="more-filters-toggle"
                        onClick={this._onMoreToggle}
                    >
                        Show {(!showMoreFilters) ? 'more' : 'less'}
                    </TextButton>
                }
            </div>
        );
    }
}
